import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { YoyakuService } from "../service/yoyaku.service";

@Component({
  selector: 'b0001-accept-modal-app',
  templateUrl: './b0001-accept-modal.component.html',
  styleUrls: ['b0001-accept-modal.component.css']
})

export class B0001AcceptModalComponent {
  @Input() tyid: any[];
  @Input() tpid: any[];


  constructor(
    public commonService: CommonService,
    public activeModal: NgbActiveModal,
    private yoyakuService: YoyakuService,
  ) { }

  ret: any = {
    status: "",
  }
  ssoAuth:boolean = false;
  qrFileCheck:boolean = true;
  isLoaded: boolean = false;

  //起動時処理
  ngOnInit(): void {
    var page_url = location.href;
    var match = page_url .includes("wellnessSupportToolsSec");
    if(match){
      this.yoyakuService.getYoyakuQrCheck(this.tpid, this.tyid)
      .subscribe((res: Response) => {
        if (res["fuel_status"] == "OK") {
          //管理者権限なのかの判定 → false=管理者
          this.isLoaded = true;
        } else {
          this.commonService.modalOpens(11013, modalresult => { 
            this.modalCloseCancel();
          });
        }
      }, error => {
        this.commonService.modalOpens(error, modalresult => { });
      });
    }else{
      this.isLoaded = true;
    }
  };
  //キャンセル時
  modalCloseCancel() {
    this.ret.status = 'Cancel';
    this.activeModal.close(this.ret);
    let status = this.ret.status
  }
  //OK押下時、親コンポーネントにチェックされた回答を渡す
  modalCloseOK() {
    this.activeModal.close(this.ret);
  }
}




// WEBPACK FOOTER //
// ./src/app/b0001-home/b0001-accept-modal.component.ts